import { render } from "./CreateTradingBankDetails.vue?vue&type=template&id=a9c2559c"
import script from "./CreateTradingBankDetails.vue?vue&type=script&lang=js"
export * from "./CreateTradingBankDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__